"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _src = require("@seedlang/utils/src");
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var WordComprehendCardWrapper = function WordComprehendCardWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _state.DeckUI.enrichWord(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "icons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (this.props.cardState.revealed && !_state.DeckUI.showLoadingIcon && (_state.DeckUI.deck.hasGrammarDescription || _state.DeckUI.deck.hasTreeNodeGrammarDescription)) {
          ary.push('deckGrammar');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (this.props.cardState.revealed) {
          ary.push('vocabCard');
        }
        return ary;
      }
    }, {
      key: "showExpandedTarget",
      get: function get() {
        return !_state.DeckUI.user.hideVocabTargetUntilRevealed || !this.props.card.hasTargetVideoClip || this.props.cardState.revealed;
      }
    }, {
      key: "showVocabTriadIntro",
      get: function get() {
        return !_state.DeckUI.deck.hideVocabTriadIntro && _state.DeckUI.deck.deckTypeIsTriad && _state.DeckUI.deck.vocabTriadWordId === this.props.card.word.id;
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        if (_state.DeckUI.deck.pronunciationDeck) {
          var _this$props$card$word, _this$props$card$word2;
          var availableHeight = _state.DeckUI.layout.contentHeight - _state.DeckUI.layout.innerDeckWidth - _state.DeckUI.layout.userInputHeight;
          if ((_this$props$card$word = this.props.card.word) !== null && _this$props$card$word !== void 0 && _this$props$card$word.isGrapheme || (_this$props$card$word2 = this.props.card.word) !== null && _this$props$card$word2 !== void 0 && _this$props$card$word2.isPhoneme) {
            return availableHeight;
          }
          return availableHeight / 2;
        } else {
          var height = _state.DeckUI.layout.heightForCardSections(3, 0, false);
          var userInputHeight = _state.DeckUI.layout.userInputHeight / 3;
          return height - userInputHeight;
        }
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        return (0, _lodash.keys)(this.arrowBoxes);
      }
    }, {
      key: "showOnboarding",
      value: function showOnboarding(slug) {
        var _this$props$card, _this$props$card2;
        return !((_this$props$card = this.props.card) !== null && _this$props$card !== void 0 && (_this$props$card = _this$props$card.cardState) !== null && _this$props$card !== void 0 && _this$props$card.onboardingTipSeen) || ((_this$props$card2 = this.props.card) === null || _this$props$card2 === void 0 || (_this$props$card2 = _this$props$card2.cardState) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.lastOnboardingTipSeen) === slug;
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        var _this2 = this;
        var arrowBox;
        (0, _lodash.each)(this.possibleArrowBoxes, function (slug) {
          if (_this2.showOnboarding(slug) && _this2.arrowBoxes[slug] && !_state.DeckUI.user.wasUiElementSeen(slug) && _state.AppUI.userCreatedInLastWeek && !arrowBox) {
            arrowBox = slug;
          }
        });
        return arrowBox;
      }
    }, {
      key: "arrowBoxes",
      get: function get() {
        var _this$props$card$word3, _this$props$card$word4, _this$props$card$word5, _this$props$card$word6;
        return {
          compareYourGermanOnboarding: (0, _src.isBlank)(this.props.card.grammarTip) && this.props.cardState.revealed,
          spacedRepetitionOnboarding: _state.DeckUI.reviewDeck && this.props.cardState.revealed,
          noteOnboarding: _state.DeckUI.reviewDeck && this.props.cardState.revealed,
          reviewIconOnboarding: (0, _src.isBlank)(this.props.card.grammarTip) && this.props.cardState.revealed,
          commentOnboarding: (0, _src.isBlank)(this.props.card.grammarTip) && this.props.card.commentsCount > 0 && this.props.cardState.revealed,
          vocabCardOnboarding: (0, _src.isBlank)(this.props.card.grammarTip) && !_state.DeckUI.reviewDeck && !_state.DeckUI.deck.hasGrammarDescription && !_state.DeckUI.deck.hasTreeNodeGrammarDescription && this.props.card.word.vocabListSentencesCount > 0 && this.props.cardState.revealed,
          repeat_sound: !this.props.cardState.revealed && !_state.DeckUI.user.blockMediaAccess && (((_this$props$card$word3 = this.props.card.word) === null || _this$props$card$word3 === void 0 ? void 0 : _this$props$card$word3.isGrapheme) || ((_this$props$card$word4 = this.props.card.word) === null || _this$props$card$word4 === void 0 ? void 0 : _this$props$card$word4.isPhoneme)),
          repeat_word: !this.props.cardState.revealed && !_state.DeckUI.user.blockMediaAccess && !((_this$props$card$word5 = this.props.card.word) !== null && _this$props$card$word5 !== void 0 && _this$props$card$word5.isGrapheme) && !((_this$props$card$word6 = this.props.card.word) !== null && _this$props$card$word6 !== void 0 && _this$props$card$word6.isPhoneme)
        };
      }
    }, {
      key: "onNextClick",
      value: function onNextClick() {
        _state.DeckUI.advanceCard(this.props.card, this.props.cardState, this.props.userCard, {
          score: _constants.Constants.EASY_SCORE,
          xp: 1,
          xpXPos: _state.DeckUI.layout.quarterDeckWidth * 2
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          icons: this.icons,
          sectionHeight: this.sectionHeight,
          showExpandedTarget: this.showExpandedTarget,
          showVocabTriadIntro: this.showVocabTriadIntro,
          possibleArrowBoxes: this.possibleArrowBoxes,
          currentArrowBox: this.currentArrowBox,
          onNextClick: this.onNextClick
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showExpandedTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showExpandedTarget"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVocabTriadIntro", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVocabTriadIntro"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showOnboarding", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "showOnboarding"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "arrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "arrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onNextClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onNextClick"), _class2.prototype), _class2)) || _class;
};
WordComprehendCardWrapper.displayName = 'WordComprehendCardWrapper';
var _default = exports["default"] = WordComprehendCardWrapper;